<template>
  <div class="header-holder">
    <div class="header-content">
      <div
          ref="marker"
          class="header-marker"
      >
        <div
            ref="icon"
            class="saved-icon"
        >
          <img :src="require('@/assets/svg/SVG/bookmark_w.svg')">
        </div>
      </div>
      <!--  {{$route.params.option}} -->
      <h2 class="header-title">
        {{ showHeader }}
      </h2>
      <ul
        v-show="$route.name === 'feed'"
        class="header-options"
      >
        <FeedOption
          v-for="(menu, index) in feedOptions"
          :key="index"
          :option="menu"
        />
      </ul>
    </div>
    <div
      v-show="this.$route.name.toLowerCase() === 'library' && RMTSearchType == 0 && !inUploadMode"
      class="view-saved"
      @mouseup="handleViewSaved"
    >
      <div class="view-feedback">
        {{ (getShowingSaved) ? 'View All' : 'View Saved' }}
      </div>
      <div class="view-icon">
        <img
          :src="require('@/assets/svg/SVG/view_saved.svg')"
          class="nav-image"
        >
      </div>
    </div>
  </div>
</template>

<script>
import { useFeedStore } from '@/store/FeedStore';
import FeedOption from '@/components/feed/FeedOption';
import { gsap } from 'gsap';
import { useRMTStore } from '@/store/RMTStore';
import { mapStores } from 'pinia/dist/pinia';

export default {
  name: 'HeaderBlock',
  components: {
    FeedOption
  },
  mounted () {
    const { marker } = this.$refs;
    gsap.fromTo(marker, {
      transformOrigin: 'top center',
      scaleY: 0
    },{
      duration: .3,
      ease: 'power4.inOut',
      scaleY:  (this.$route.name === 'feed') ? 1 : 1,
    });
    gsap.set(this.$refs.icon, {
      autoAlpha: 0
    });
  },
  computed: {
    ...mapStores(useFeedStore, useRMTStore),
    showHeader () {
      return this.$route.name;
    },
    RMTSearchType () {
      const RMTStore = useRMTStore();
      return RMTStore.getSearchType;
    },
    getShowingSaved () {
      const RMTStore = useRMTStore();
      return RMTStore.getShowingSaved;
    },
    feedOptions () {
      const feedStore = useFeedStore();
      return feedStore.getFeedOptions;
    },
    inUploadMode () {
      const RMTStore = useRMTStore();
      return RMTStore.inUploadMode;
    }
  },
  methods: {
    toggleShowingSaved () {
      return this.RMTStore.toggleShowingSaved();
    },
    handleViewSaved () {
      this.toggleShowingSaved();
      gsap.to(this.$refs.marker, {
        width: (this.getShowingSaved) ? 100 + 'px' : 5 + 'px',
        duration: .5,
        ease: 'power4.inOut'
      });
      gsap.to(this.$refs.icon, {
        autoAlpha: (this.getShowingSaved) ? 1 : 0,
        duration: .5,
        ease: 'power4.inOut'
      });
    }
  }
};
</script>

<style scoped>
.header-holder {
  display: flex;
  flex-direction: row;
  width:100%;
  min-height: 70px;
/*  background-color: red;*/
}
.header-title {
  text-transform: capitalize;
  margin-top: 20px;
  margin-left: 20px;
}
.header-options {
  width: 100%;
  vertical-align: middle;
  margin-top: 0px;
  margin-left: 20px;
}
.header-content {
  width: 100%;
  display: flex;
}
.header-marker {
  width:5px;
  background-color: #0088ca;
  display: flex;
  justify-content: center;
  align-items: center;
}
.saved-icon {
  width: 20px;
  height: 25px;
}
.view-saved {
  cursor: pointer;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  padding: 20px;
}
.view-feedback {
  padding-right: 10px;
  font-size: .8em;
  font-weight: bold;
  white-space: nowrap;
}
.view-icon {
  width: 16px;
}
</style>
